export default __webpack_public_path__ + "static/currents-map-e769c35a59c3c79f35eba8f76dc4712d.mp4";